module.exports = __webpack_public_path__ + "img/topup-card.eac3a503.svg";